var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50023 1.47788C5.66678 1.47788 2.65464 4.38704 2.65464 8.01301C2.65464 8.89954 2.95465 10.0061 3.46375 11.1895C3.96984 12.3658 4.66877 13.5864 5.43407 14.6914C6.20007 15.7974 7.02396 16.7752 7.77445 17.4711C8.15005 17.8195 8.49862 18.0891 8.80474 18.2693C9.11847 18.4539 9.34961 18.522 9.50023 18.522C9.65084 18.522 9.88199 18.4539 10.1957 18.2693C10.5018 18.0891 10.8504 17.8195 11.226 17.4711C11.9765 16.7752 12.8004 15.7974 13.5664 14.6914C14.3317 13.5864 15.0306 12.3658 15.5367 11.1895C16.0458 10.0061 16.3458 8.89954 16.3458 8.01301C16.3458 4.38704 13.3337 1.47788 9.50023 1.47788ZM1.81641 8.01301C1.81641 3.88997 5.23872 0.639648 9.50023 0.639648C13.7617 0.639648 17.1841 3.88997 17.1841 8.01301C17.1841 9.06374 16.8354 10.2918 16.3067 11.5207C15.775 12.7566 15.0469 14.0259 14.2555 15.1686C13.4648 16.3103 12.6022 17.3381 11.796 18.0858C11.3932 18.4593 10.9959 18.771 10.6209 18.9917C10.2536 19.2079 9.86852 19.3602 9.50023 19.3602C9.13194 19.3602 8.74688 19.2079 8.37954 18.9917C8.00459 18.771 7.60723 18.4593 7.20447 18.0858C6.39825 17.3381 5.53568 16.3103 4.74496 15.1686C3.95354 14.0259 3.22547 12.7566 2.69375 11.5207C2.16503 10.2918 1.81641 9.06374 1.81641 8.01301Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50009 5.38975C7.87978 5.38975 6.56626 6.70327 6.56626 8.32357C6.56626 9.94388 7.87978 11.2574 9.50009 11.2574C11.1204 11.2574 12.4339 9.94388 12.4339 8.32357C12.4339 6.70327 11.1204 5.38975 9.50009 5.38975ZM5.72803 8.32357C5.72803 6.24032 7.41684 4.55151 9.50009 4.55151C11.5833 4.55151 13.2721 6.24032 13.2721 8.32357C13.2721 10.4068 11.5833 12.0956 9.50009 12.0956C7.41684 12.0956 5.72803 10.4068 5.72803 8.32357Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/MapPin.b497d6e1e3e8919c099535e36e0e3c09.svg";
export { ForwardRef as ReactComponent };